import { useCallback, useRef } from 'react';

type Props = {
  isLoading: boolean;
  isFetching: boolean;
  isFetchingNextPage: boolean;
  hasNextPage?: boolean;
  onLoadMore: () => void;
};

const useInfiniteScrollTrigger = ({ isLoading, isFetching, isFetchingNextPage, hasNextPage, onLoadMore }: Props) => {
  const observer = useRef<IntersectionObserver | null>(null);

  const lastElementRef = useCallback(
    (node: HTMLElement | null) => {
      if (isLoading || isFetching || isFetchingNextPage) {
        return;
      }

      if (observer.current) {
        observer.current.disconnect();
      }

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          onLoadMore();
        }
      });

      if (node) {
        observer.current.observe(node);
      }
    },
    [hasNextPage, isFetching, isFetchingNextPage, isLoading, onLoadMore]
  );

  return { lastElementRef };
};

export default useInfiniteScrollTrigger;
